/* eslint-disable max-len */

import locale from '../translations/categories'

export const MAIN_CATEGORIES = [
  {
    value: 'business',
    locale: locale.business,
    descriptionLocale: locale.businessDescription,
    imageUrl: 'https://www.universe.com/multiverse/assets/images/templates/index/categories/business-148add6ca3ab6f2dbc04a4e50dedf411.jpg',
  },
  {
    value: 'comedy',
    locale: locale.comedy,
    descriptionLocale: locale.comedyDescription,
    imageUrl: 'https://www.universe.com/multiverse/assets/images/templates/index/categories/comedy-0cd7fac043ce7ad78a97b51ca6de4b09.jpg',
  },
  {
    value: 'crafts',
    locale: locale.crafts,
    descriptionLocale: locale.craftsDescription,
    imageUrl: 'https://www.universe.com/multiverse/assets/images/templates/index/categories/crafts-8925803faabf1938be2199225fb354c7.jpg',
  },
  {
    value: 'fashion',
    locale: locale.fashion,
    descriptionLocale: locale.fashionDescription,
    imageUrl: 'https://www.universe.com/multiverse/assets/images/templates/index/categories/fashion-5008570618ddd2d510db08f792b338d6.jpg',
  },
  {
    value: 'film',
    locale: locale.film,
    descriptionLocale: locale.filmDescription,
    imageUrl: 'https://www.universe.com/multiverse/assets/images/templates/index/categories/film-dd5c7f70af2a406ee8bb069c96ec0400.jpg',
  },
  {
    value: 'food-drink',
    locale: locale.foodDrink,
    descriptionLocale: locale.foodDrinkDescription,
    imageUrl: 'https://www.universe.com/multiverse/assets/images/templates/index/categories/food-6c05c282ea76c62b4794f2157f482083.jpg',
  },
  {
    value: 'galleries-museums',
    locale: locale.galleries,
    descriptionLocale: locale.galleriesDescription,
    imageUrl: 'https://www.universe.com/multiverse/assets/images/templates/index/categories/galleries-60f079fba61e52ebe79a0e38fc52113c.jpg',
  },
  {
    value: 'music',
    locale: locale.music,
    descriptionLocale: locale.musicDescription,
    imageUrl: 'https://www.universe.com/multiverse/assets/images/templates/index/categories/music-83367ddcdd0cb088b4148a19fcf0b39b.jpg',
  },
  {
    value: 'performing-arts',
    locale: locale.performances,
    descriptionLocale: locale.performancesDescription,
    imageUrl: 'https://www.universe.com/multiverse/assets/images/templates/index/categories/performances-dfc908eda5a63a550a311fd3f15091cb.jpg',
  },
  {
    value: 'social',
    locale: locale.social,
    descriptionLocale: locale.socialDescription,
    imageUrl: 'https://www.universe.com/multiverse/assets/images/templates/index/categories/social-a0b25a87d07dce8ac2e24987a194e8cf.jpg',
  },
  {
    value: 'sports',
    locale: locale.sports,
    descriptionLocale: locale.sportsDescription,
    imageUrl: 'https://www.universe.com/multiverse/assets/images/templates/index/categories/sports-f917b993c2ea9e4aaf98b08cf588b901.jpg',
  },
  {
    value: 'tech',
    locale: locale.tech,
    descriptionLocale: locale.techDescription,
    imageUrl: 'https://www.universe.com/multiverse/assets/images/templates/index/categories/technology-22b1fddaad61d73df645018b8be0646f.jpg',
  },
]

export const OTHER_CATEGORY = {
  value: 'other',
  locale: locale.other,
}
